import { Component, Inject, Optional } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OrderDetailsRow } from '../imaging-request-orders-details/imaging-request-orders-details.component';
import { DateTime } from 'luxon';
import { SnackbarService } from '@app/services/snackbar.sevice';

@Component({
    selector: 'app-imaging-request-order-details-modal',
    templateUrl: './imaging-request-order-details-modal.component.html',
    styleUrl: './imaging-request-order-details-modal.component.scss'
})
export class ImagingRequestOrderDetailsModalComponent {
    private static readonly NewLinesRegex: RegExp = /\r?\n/;
    private static readonly ReportMissingText: string[] = [
        'Report unexpectedly missing.',
        'Please try opening this report again, and contact Everlight support if this error persists.'
    ];

    reportText: string[];
    signTime: string;

    constructor(
        private readonly clipboard: Clipboard,
        private readonly snackbarService: SnackbarService,
        @Optional() public dialogRef: MatDialogRef<ImagingRequestOrderDetailsModalComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: OrderDetailsRow
    ) {
        if (data) {
            this.reportText = data.reportText.split(ImagingRequestOrderDetailsModalComponent.NewLinesRegex);
            this.signTime = DateTime.fromISO(data.signTime).toLocaleString(DateTime.DATETIME_MED_WITH_WEEKDAY);
        } else {
            this.reportText = ImagingRequestOrderDetailsModalComponent.ReportMissingText;
            console.error('No report text available!');
        }
    }

    copyReport(): void {
        const clipboardText = `${this.reportText.join('\r\n')}\r\nReport signed at: ${this.signTime}`;
        this.clipboard.copy(clipboardText);
        this.snackbarService.openSnackBar('Copied to clipboard', SnackbarService.SNACK_BAR_CLASS_SUCCESS);
    }

    closeReport(): void {
        this.dialogRef.close();
    }
}
